import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { Company } from '../../shared/models/core/company';
import { IPagedResult } from '../../shared/models/paged-result';

export const companyApi = createApi({
  reducerPath: 'companyApi',
  baseQuery,
  endpoints: (builder) => ({
    getCompanies: builder.query<IPagedResult<Company>, void>({
      query: () => ({
        url: `/api/companies?size=-1`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCompaniesQuery } = companyApi;
